// Per-app bootstrap (frontend split epic, replicate list) — each app owns
// its own Amplify.configure() call rather than sharing one; extracting this
// into packages/ui would force all four apps to release in lockstep for a
// call that's rarely changed.
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { desktop, restoreAuthPersistence } from "@livingsyncs/ui";

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

if (!userPoolId || !userPoolClientId) {
  throw new Error(
    "Missing Cognito environment variables: VITE_COGNITO_USER_POOL_ID, VITE_COGNITO_CLIENT_ID",
  );
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: { email: true },
      mfa: { status: "on", totpEnabled: true },
    },
  },
});

// apps/auditor is web-only (no desktop shell), but keeping the same branch
// frontend/gateway/admin use costs nothing and keeps the four apps'
// bootstrap files identical in shape.
if (desktop?.tokenStore.available) {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(desktop.tokenStore);
} else {
  restoreAuthPersistence();
}
